import React from 'react'
import * as types from 'common/types'

export const MapStyles: types.MapStyle[] = [
  {
    id: 'streets',
    name: '標準地図',
    url: 'mapbox://styles/ctie-yagami/cm3wfpnk3002e01rc442fa6wc'
  },
]

export const IDs = {
  hazardMap: {
    layer: 'hazard-map-layer',
    source: 'hazard-map-source'
  },
  centerLine: 'center-line'
}

export const QuestionPages: types.QuestionPage[] = [
  {
    q: -1,
    to: '/0',
    title: '基本情報',
    subtitle: '',
    heading: '',
    content: '利用者情報入力',
    count: 13
  },
  {
    q: 0,
    to: '/map',
    title: '水害リスク評価',
    subtitle: '外水・内水氾濫共通',
    heading: '',
    content: '評価する物件位置を選択してください',
    count: 1
  },
  {
    q: 1,
    to: '/1-4',
    title: '水害リスク評価',
    subtitle: '外水氾濫',
    heading: '頑強性（立地）',
    content: '想定最大規模の降雨時における外水氾濫のリスクに関しての確認',
    count: 1
  },
  {
    q: 2,
    to: '/1-4',
    title: '水害リスク評価',
    subtitle: '外水氾濫',
    heading: '頑強性（立地）',
    content: '年超過確率1/200（200年に一度）規模の降雨時における外水氾濫のリスクに関しての確認',
    count: 1
  },
  {
    q: 3,
    to: '/1-4',
    title: '水害リスク評価',
    subtitle: '外水氾濫',
    heading: '頑強性（立地）',
    content: '家屋倒壊等氾濫想定区域（河岸侵食エリア）に関しての確認',
    count: 1
  },
  {
    q: 4,
    to: '/1-4',
    title: '水害リスク評価',
    subtitle: '内水氾濫',
    heading: '頑強性（立地）',
    content: '想定最大規模の降雨時における内水氾濫のリスクに関しての確認',
    count: 1
  },
  {
    q: 5,
    to: '/5',
    title: '水害リスク評価',
    subtitle: '外水・内水氾濫共通',
    heading: '頑強性（立地・建物）',
    content: '浸水位と建物各部の高さを比較し、外水・内水の建物内への流入の可能性の確認',
    count: 2
  },
  {
    q: 6,
    to: '/6',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '頑強性（立地・建物）',
    content: '立地及び建物の水防に関しての確認',
    count: 7
  },
  {
    q: 7,
    to: '/7',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '頑強性（立地・建物）',
    content: '公共の雨水・下水本管から建物内への逆流を防止する対策に関しての確認',
    count: 3
  },
  {
    q: 8,
    to: '/8',
    title: '水害対策評価',
    subtitle: '外水氾濫',
    heading: '頑強性（建物）',
    content: '年超過確率1/200規模の降雨時に関して、各種設備と最大浸水位（浸水面の標高）及び水防ラインとの高さと位置の確認',
    count: 12
  },
  {
    q: 9,
    to: '/9',
    title: '水害対策評価',
    subtitle: '内水氾濫',
    heading: '頑強性（建物）',
    content: '想定最大規模の降雨時に関して、各種設備と最大浸水位（浸水面の標高）及び水防ラインとの高さと位置の確認',
    count: 12
  },
  {
    q: 10,
    to: '/10',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '冗長性',
    content: '停電時の対策に関しての確認',
    count: 5
  },
  {
    q: 11,
    to: '/11',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '冗長性',
    content: '給排水ガス遮断時の対策についての確認',
    count: 6
  },
  {
    q: 12,
    to: '/12',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '冗長性',
    content: '敷地内雨水処理',
    count: 1
  },
  {
    q: 13,
    to: '/13',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '冗長性',
    content: '自然換気',
    count: 1
  },
  {
    q: 14,
    to: '/14',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '即応性',
    content: '災害時の対応人員、体制、事前準備に関しての確認',
    count: 6
  },
  {
    q: 15,
    to: '/15',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '即応性',
    content: '訓練・テナント周知に関しての確認',
    count: 4
  },
  {
    q: 16,
    to: '/16',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '代替性',
    content: '災害対策備品等の整備・点検状況に関しての確認',
    count: 7
  },
  {
    q: 17,
    to: '/17',
    title: '水害対策評価',
    subtitle: '外水・内水氾濫共通',
    heading: '先進的取組・地域貢献',
    content: '先進的取組や地域貢献に関しての確認',
    count: 6
  }
]
